import { PageSectionTitle as SectionTitle } from '@applyonline/shared'
import { Trans, useTranslation } from 'react-i18next'
import { Link, useNavigate } from 'react-router-dom'
import StepCard from '../../components/Card/Card'
import StepCardContainer from '../../components/Card/CardContainer'
import useFaqLink from '../../hooks/useFaqLink'
import { trackPlainEvent } from '../../services/trackingEvents'
import { ETrackingEvent } from '../../types/tracking'

const WelcomePage = () => {
  const { t } = useTranslation()

  const navigate = useNavigate()
  const faqLink = useFaqLink()

  const handleGetStarted = () => {
    trackPlainEvent(ETrackingEvent.GetStarted)
    navigate(`/eligibility`, { replace: true })
  }

  return (
    <main className="step-0">
      <div className="strong" style={{ marginBottom: '2rem', fontSize: '0.9em' }}>
        {t('eligibility.preApproved')}
      </div>
      <SectionTitle title={t('welcome.applyInMinutes')} />
      <h1>{t('welcome.prequalifiedRapidly')}</h1>
      <div className="paragraph">
        <p style={{ fontSize: '0.9em' }}>{t('welcome.answerQuestions')}</p>
      </div>
      <StepCardContainer>
        <StepCard icon="address-card" description={t('welcome.yourself')} />
        <StepCard icon="memo-circle-check" description={t('welcome.validateIcome')} />
        <StepCard icon="hand-holding-circle-dollar" description={t('welcome.selectPlan')} />
      </StepCardContainer>
      <button id="btnBegin" type="button" onClick={handleGetStarted} className="btn btn-blue">
        {t('welcome.getStarted')}
        <i className="fa-regular fa-arrow-right" />
      </button>
      <p style={{ fontSize: '1.5rem', marginTop: '1rem' }}>
        <Trans
          i18nKey="welcome.question"
          components={{
            site_anchor: <Link to={faqLink} target="_blank" />,
          }}
        />
      </p>
    </main>
  )
}

export default WelcomePage
